import React, { ReactNode } from 'react';
import './Patterns.css';

export interface FieldProps {
  label: string;
  /** Marks the field with a red asterisk; consumers must also set `required` on the control. */
  required?: boolean;
  /** Optional helper text shown beneath the control. */
  helpText?: ReactNode;
  /** Optional error message; replaces helpText when present and applies error styling. */
  errorText?: ReactNode;
  /** id of the inner control — used as the label's `for` attribute. */
  controlId?: string;
  children: ReactNode;
}

const Field: React.FC<FieldProps> = ({ label, required, helpText, errorText, controlId, children }) => {
  const hasError = Boolean(errorText);
  return (
    <div className={`pat-field${hasError ? ' pat-field--error' : ''}`} data-testid="field">
      <label className="pat-field__label" htmlFor={controlId}>
        {label}
        {required && <span className="pat-field__required" aria-hidden="true">*</span>}
        {required && <span className="visually-hidden"> (required)</span>}
      </label>
      <div className="pat-field__control">{children}</div>
      {hasError ? (
        <div className="pat-field__error" role="alert">{errorText}</div>
      ) : helpText ? (
        <div className="pat-field__help">{helpText}</div>
      ) : null}
    </div>
  );
};

export default Field;
